<template>
  <div>
    <GeocodeDialog
      :showProp="show && showGeocodeDialog"
      v-model="newLocation"
      :delivery="delivery"
      @close="showGeocodeDialog=false;show=false;"
      @done="postGeocode"
    ></GeocodeDialog>

    <v-dialog v-model="show" v-if="!showGeocodeDialog" width="500px">
      <v-card>
        <v-card-title>
       <h3>Redirect Delivery</h3>
        </v-card-title>

        <v-divider color="#42a5f5"></v-divider>

        <v-card-text>
          <v-row >
            <v-col md="9" cols="12">
              <v-text-field
                label="New Address"
                v-model="newAddress"
                disabled
              ></v-text-field>
            </v-col>
            <v-col md="3" cols="12" class="text-center">
              <v-btn rounded @click="showGeocodeDialog=true" color="secondary">Change</v-btn>
            </v-col>
           </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-if="zone !== null && zone !== undefined"
                  v-model="zone.name"
                  label="Zone"
                  disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="date"
                      label="Date"
                      prepend-icon="fas fa-calendar"
                      readonly
                      @click.native="menu = true"
                  >
                    <template v-slot:append>
                      <v-btn rounded small @click="date=null" color="secondary">Clear</v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu = false" style="width: 100%" :allowed-dates="allowedDates"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
          <v-col cols="12" v-if="noZoneFound">
            <v-alert
              type="warning"
              dense
              outlined
              color="orange darken-2"
              icon="mdi-alert-circle-outline"
            >
              Could not find the zone by postcode
              <strong>{{ this.newLocation.postcode }}</strong>
              and suburb
              <strong>{{ this.newLocation.suburb }}</strong>.
            </v-alert>
          </v-col>
          </v-row>
           <v-row>
            <v-col cols="12">
              <v-select
                :items="renderedAvailableTimeWindows"
                item-text="display"
                return-object
                v-model="newTimeWindow"
                label="Time Window"
              ></v-select>
            </v-col>
           </v-row>
           <v-row>
            <v-col cols="12" v-if="overridePermission">
              <v-switch
                style="justify-content: center"
                color="blue"
                v-model="overrideSwitch"
                :label="overrideSwitch ? 'Ignore Cut Off' : 'Enforce Cut Off'"
              ></v-switch>
            </v-col>
           </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="show=false">Cancel</v-btn>
          <v-btn text color="blue darken-1" @click="redirect">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import GeocodeDialog from "./GeocodeDialog";

  export default {
    name: "DeliveryRedirectDialog",
    components: {GeocodeDialog},
    props: {
      tracking: String,
      delivery: {
        type: Object,
        default: null
      },
      showProp: Boolean,

    },
    data() {
      return {
        address: null,
        newLocation: null,
        newTimeWindow: null,
        overrideSwitch: false,
        showGeocodeDialog: true,
        date: null,
        liteDates: [],
        availableTimeWindows: [],
        listTimeWindows: [],
        menu: false,
      }
    },
    computed: {
      show: {
        get() {
          return this.showProp;
        },
        set(value) {
          this.showGeocodeDialog = true;
          if (!value) this.$emit('close');
        }
      },
      renderedAvailableTimeWindows(){
        if (this.setavailableTimeWindows === undefined || this.setavailableTimeWindows === null) return [];
        return this.setavailableTimeWindows;
      },
      overridePermission() {
        if (this.delivery !== null) {
          return this.$store.getters['auth/hasPermissionRegionId']('delivery_violate_cutoffs', this.delivery.region_id);
        } else {
          return this.$store.getters['auth/hasPermission']('delivery_violate_cutoffs');
        }
      },
      newAddress() {
        if (this.newLocation === null) return null;
        let s = this.newLocation.street1 + ", ";
        if (this.newLocation.street2 !== null && this.newLocation.street2.length() > 0) s += this.newLocation.street2 + ", ";
        s += this.newLocation.suburb + " " + this.newLocation.state + " " + this.newLocation.postcode;
        return s;
      },
      noZoneFound() {
        const noWindows = !this.renderedAvailableTimeWindows.length;
        let noDates = true;

        if (typeof this.allowedDates === "function") {
          const today = new Date();
          for (let i = 0; i < 30; i++) {
            const d = new Date(today);
            d.setDate(today.getDate() + i);
            const ymd = d.toISOString().split("T")[0];
            if (this.allowedDates(ymd)) {
              noDates = false;
              break;
            }
          }
        }
        return noWindows || noDates;
      },
    },
    asyncComputed: {
      async zone() {
        if (this.newLocation !== null) {
          let countryCode = 'AUS';
          if(this.newLocation.country === 'Australia'){
            countryCode = 'AUS';
          } else  countryCode = 'NZL';
          return await axios.get(process.env.API_URL + '/zones?postcode=' + this.newLocation.postcode + '&country=' + countryCode)
              .then((response) => {
                return response.data;
              })
              .catch((err) => {
                return null;
              })
        }
      },
      async setavailableTimeWindows(){
        console.log('setavailableTimeWindows');

        let found = this.isTimeWindosChange();
        if(!found){
          if (this.date){
            this.availableTimeWindows = this.listTimeWindows.filter(tw => tw.date === this.date);
          } else {
            this.availableTimeWindows = [];
          }
        }
        return this.availableTimeWindows;
      },
      async getDefaultTimeWindows() {
          if (this.delivery === null) {
            return [];
          }
          if(this.newLocation.postcode != null){
            this.delivery.postcode = this.newLocation.postcode;
          }
          axios.get(process.env.API_URL + '/deliveries/optionsadv?client_id=' + this.delivery.client_id + '&postcode=' + this.delivery.postcode +
            '&suburb=' + this.newLocation.suburb + '&service_id=' + this.delivery.service_id + '&reschedule=' + true + '&max_options=20')
              .then((response) => {
                console.log('default');
                if (response.status === 200) {
                  console.log('Available Time windows found');
                  if (response.data.length > 0) {
                    this.listTimeWindows =  response.data.map((tw) => {
                      tw.id = tw.timewindow_id;
                      tw.display = 'From ' + tw.time_start + ' - To ' + tw.time_end;
                      return tw;
                    });
                    this.newTimeWindow = this.listTimeWindows[0];
                    this.liteDates = this.listTimeWindows.map((tw) => {return tw.date});
                    this.date = this.newTimeWindow.date;
                    this.setavailableTimeWindows();
                  } else {
                    this.newTimeWindow = null;
                  }
                } else {
                  console.log('No available time window');
                }
              })
          .catch((err) => {
            return null;
          })
      },
    },
    methods: {
      redirect() {
        if (this.newTimeWindow === null) {
          this.$store.commit('displaySnackbar', 'Must choose time window');
          return false;
        }
          this.$store.commit('displayWaitDialog', true);
          this.$emit('changeLoading', true);
        let data = Object.assign({}, this.newLocation);
        data.ignore_cutoff = this.overrideSwitch;
        if (this.hasTwChanged(this.newTimeWindow.start, this.newTimeWindow.end)) {
          data.time_window = this.newTimeWindow.id;
          data.date = this.date;
        }
        axios.post(process.env.API_URL + '/deliveries/' + this.tracking + '/redirect', data)
            .then((response) => {
              this.$store.commit('displaySnackbar', 'Successfully redirected delivery');
              this.show = false;
                this.$store.commit('displayWaitDialog', false);
                this.$emit('changeLoading', false);
            })
            .catch((err) => {
                this.$store.commit('displaySnackbar', 'Error: '+(err.response === undefined ? 'Unknown error' : err.response.data.error)) ;
                this.$store.commit('displayWaitDialog', false);
                this.$emit('changeLoading', false);
            });

      },
      close() {
        this.showGeocodeDialog = false;
        this.show = false;
      },
      postGeocode(data) {
        if (data !== null) {
          this.newLocation = data;
        } else {
          this.$store.commit('displaySnackbar', 'Geocode failed');
        }
        this.showGeocodeDialog = false;
      },
      hasTwChanged(start, end) {
        if (this.delivery === null) return true;
        return start !== this.delivery.time_window_start.substring(11, 16) || end !== this.delivery.time_window_end.substring(11, 16);
      },
      allowedDates(val){
        return this.liteDates.includes(val);
      },
      isTimeWindosChange() {
          let found = false;
          if (this.delivery.time_window_start === null || this.delivery.time_window_end === null) {
            return false;
          } else {
            let start = this.delivery.time_window_start.split(' ')[1];
            start = start.substring(0, start.lastIndexOf(':'));
            let end = this.delivery.time_window_end.split(' ')[1];
            end = end.substring(0, end.lastIndexOf(':'));

            if (this.listTimeWindows) {
              for (let i in this.listTimeWindows) {
                if (this.listTimeWindows[i].date === this.delivery.date){

                  this.availableTimeWindows.push(this.listTimeWindows[i]);
                  if(this.listTimeWindows[i].time_start === start
                    && this.listTimeWindows[i].time_end === end) {
                    this.newTimeWindow = this.listTimeWindows[i];
                    this.date = this.delivery.date;
                    found = true;
                  }
                }
              }
            }
          }

          return found;
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/DeliveryRedirectDialog.vue